import React from "react";
import Col from "react-bootstrap/lib/Col";
import { bool, string } from "prop-types";
import { Field, Form, withFormik } from "formik";
import { compose } from "redux";
import { connect } from "react-redux";
import * as Yup from "yup";
import { selectors as sessionSelectors } from "reducers/session";
import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import TextArea from "pages/_components/fields/TextArea";
import TextField from "pages/_components/fields/TextField";
import I18n from "pages/_components/I18n";
import PageLoading from "pages/_components/PageLoading";
import * as i18n from "util/i18n";
import { actions as discountsActions } from "reducers/discounts";
import { emailRegex } from "util/form";

const FORM_ID = "discountecheq.share";

const Compose = (props) => {
    const { isFetching, email } = props;

    return (
        <PageLoading loading={isFetching}>
            <Form className="above-the-fold">
                <Container className="flex-grow items-center container--layout">
                    <Col className="col-12">
                        <div className="view-title">
                            <h2>
                                <I18n id="discountecheq.drawer.share" />
                            </h2>
                        </div>
                        <Field component={TextField} idForm={FORM_ID} name="toAddress" type="text" maxLength={100} />

                        <h3>
                            <p>
                                <I18n id="discountecheq.share.fromAddress" />
                            </p>
                            {email}
                        </h3>

                        <Field
                            hidePlaceholder
                            hideLabel
                            component={TextArea}
                            idForm={FORM_ID}
                            name="body"
                            maxLength={1500}
                        />

                        <Button bsStyle="primary" label="communications.compose.send" type="submit" />
                    </Col>
                </Container>
            </Form>
        </PageLoading>
    );
};

Compose.propTypes = {
    isFetching: bool.isRequired,
    email: string.isRequired,
};

const mapsStateToProps = (state) => ({
    isFetching: sessionSelectors.isFetching(state),
    email: sessionSelectors.getUsername(state),
});

export default compose(
    connect(mapsStateToProps),
    withFormik({
        validateOnChange: true,
        validateOnBlur: false,
        enableReinitialize: true,
        mapPropsToValues: () => ({
            toAddress: "",
            body: "",
            tray: "",
        }),
        validationSchema: () =>
            Yup.object().shape({
                toAddress: Yup.string()
                    .required(i18n.get("discountecheq.address.required"))
                    .test(
                        "format",
                        i18n.get("discountecheq.address.error.invalidFormat"),
                        (value) => !!value && emailRegex.test(value),
                    ),
                body: Yup.string()
                    .trim()
                    .required(i18n.get("discountecheq.body.required")),
            }),
        handleSubmit: (fields, { props }) => {
            const request = {
                transactionId: props.idTransaction,
                toAddress: fields.toAddress,
                body: fields.body,
            };
            props.dispatch(discountsActions.sendTransactionTicket(request));
        },
    }),
)(Compose);
